import { reviewItems } from "../../../mocks/hotNews";
import SectionHeading from "./SectionHeading";

const stats = [
  { num: "1260万+", label: "累计围观热度" },
  { num: "98.6%", label: "讨论覆盖栏目" },
  { num: "31万+", label: "前排围观用户" },
  { num: "24h", label: "热度实时更新" },
];

const values = [
  { icon: "ri-time-line", title: "现场直击", desc: "紧跟时间线还原来龙去脉，让每一次发酵都有迹可循。" },
  { icon: "ri-compass-3-line", title: "客观看风向", desc: "把不同观点摆到台前，只汇总公开讨论，不做情绪站队。" },
  { icon: "ri-focus-3-line", title: "信息可溯源", desc: "尽量标注来源与时间，帮助围观群众自己判断可信度。" },
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="关于我们"
          title="看料门是谁，我们围观什么"
          desc="看料门是一个聚焦全网公开热议话题的内容聚合与围观平台，我们想做的，是帮你以最舒服的“前排视角”看懂每一场热闹。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-7 lg:col-span-2">
            <h3 className="font-heading text-xl text-foreground-950 md:text-2xl">我们在做一件“把热闹讲清楚”的小事</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              每天网络上都有新的名场面、新的话题和新的风向在滚动。它们散落在不同角落，讨论常常断断续续、前后矛盾，围观群众很容易看一半就“吃不明白瓜”。
              看料门把散落的碎片按时间与主题重新拼好：从一条热讯的现场直击，到一次名场面的逐帧复盘，再到一场反转连续剧的完整还原——
              我们不替你做判断，只负责把过程、观点与公开信息一起摆到你面前，让你真的看懂“热闹从哪儿来、又往哪儿去”。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">
              我们希望你在看料门前排入座时，收获的不只是“又吃到一个瓜”的即时快乐，更是对话题更完整的理解。热闹会散，但好好围观过的每一场，都值得被讲清楚。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {values.map((v) => (
                <div key={v.title} className="rounded-2xl bg-background-100 p-5">
                  <i className={`${v.icon} text-xl text-primary-500`}></i>
                  <h4 className="mt-3 text-sm font-bold text-foreground-900">{v.title}</h4>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-2 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl border border-background-200 bg-background-50 p-5 text-center">
                  <p className="font-display text-xl text-primary-600 md:text-2xl">{s.num}</p>
                  <p className="mt-1 text-[11px] text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="rounded-2xl bg-primary-500 p-6 text-background-50">
              <div className="flex items-center gap-2">
                <i className="ri-mail-send-line text-xl"></i>
                <h4 className="font-heading text-lg">投稿 / 纠错 / 合作</h4>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-background-50/85">
                有值得围观的线索或希望我们校正的内容？欢迎随时联系看料门编辑部。
              </p>
              <a
                href="mailto:hello@kanliaomen.example"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-accent-200"
              >
                hello@kanliaomen.example
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10">
          <h3 className="mb-5 flex items-center gap-2 font-heading text-xl text-foreground-950 md:text-2xl">
            <i className="ri-chat-3-line text-primary-500"></i>
            前排围观群众的真实声音
          </h3>
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {reviewItems.map((r) => (
              <figure key={r.id} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: r.stars }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <blockquote className="mt-3 text-sm leading-relaxed text-foreground-800">“{r.text}”</blockquote>
                <figcaption className="mt-4 flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-heading text-sm text-primary-700">
                    {r.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-900">{r.name}</p>
                    <p className="text-xs text-foreground-500">{r.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}